import React from "react";
import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import "./copy-right.m.css";

export default function CopyRight() {
  return (
    <div styleName="wrapper">
      <div styleName="gn-copy-right">
        <span>
          <SvgIconHandler type="gn-reach-icon" width="114px" height="36px" viewBox="0 0 114 36" />
        </span>
        <p>This content comes from Reach by Gulf News, which is the branded content team of GN Media.</p>
      </div>
    </div>
  );
}
